<template>
  <div class="mg-page">
    <!-- Sarlavha -->
    <div class="mg-header">
      <h3 class="mg-title">🎁 Ustaga sovg'a / to'lov</h3>

      <!-- Kategoriya tanlash -->
      <div class="mg-cats">
        <button
          class="mg-cat"
          :class="{ active: activeCat === 'aksiya' }"
          @click="selectCat('aksiya')"
        >
          <span class="mg-cat-ic">🎯</span>
          <span class="mg-cat-name">Aksiya mahsulot</span>
          <span class="mg-cat-sub">balldan ayiriladi</span>
        </button>
        <button
          class="mg-cat"
          :class="{ active: activeCat === 'ombor' }"
          @click="selectCat('ombor')"
        >
          <span class="mg-cat-ic">📦</span>
          <span class="mg-cat-name">Ombor mahsulot</span>
          <span class="mg-cat-sub">ball/bonusdan ayiriladi</span>
        </button>
        <button
          class="mg-cat"
          :class="{ active: activeCat === 'cash' }"
          @click="selectCat('cash')"
        >
          <span class="mg-cat-ic">💵</span>
          <span class="mg-cat-name">Pul berish</span>
          <span class="mg-cat-sub">balansdan + kassadan chiqim</span>
        </button>
      </div>

      <!-- Usta tanlash + balans -->
      <div class="mg-head-row">
        <div class="mg-usta-pick">
          <label class="mg-label">Usta</label>
          <v-select
            :options="ustalar"
            label="name"
            :reduce="u => u.id"
            v-model="staff_id"
            @input="onUstaChange"
            placeholder="Ustani tanlang..."
          >
            <template #option="u">
              {{ u.name }}
              <small v-if="u.phone_number" style="color:#888"
                >— {{ u.phone_number }}</small
              >
            </template>
          </v-select>
        </div>

        <div v-if="staff_id && ustaInfo" class="mg-balance">
          <div class="mg-bal-row">
            <span class="mg-bal-label">💰 Pul balansi</span>
            <span class="mg-bal-val"
              >{{ ustaInfo.money_balance | numFormat }} so'm</span
            >
          </div>
          <div
            v-if="ustaInfo.ball_per_sum > 0 || ustaInfo.ball_balance > 0"
            class="mg-bal-row"
          >
            <span class="mg-bal-label">🎯 Ball balansi</span>
            <span class="mg-bal-val"
              >{{ ustaInfo.ball_balance | numFormat }} ball
              <small v-if="ustaInfo.ball_value_sum"
                >≈ {{ ustaInfo.ball_value_sum | numFormat }} so'm</small
              ></span
            >
          </div>
          <div v-if="ustaInfo.ball_per_sum > 0" class="mg-bal-row">
            <span class="mg-bal-label">📈 Ball limiti</span>
            <span class="mg-bal-val"
              >{{ ustaInfo.ball_progress | numFormat }} so'm
              <small
                >(jami ≈ {{ ustaInfo.available_value | numFormat }} so'm)</small
              ></span
            >
          </div>
        </div>
      </div>
    </div>

    <div v-if="!staff_id" class="mg-empty">⬆️ Avval ustani tanlang</div>

    <!-- ════════ OMBOR MAHSULOT ════════ -->
    <div v-else-if="activeCat === 'ombor'" class="mg-body">
      <div class="mg-browser">
        <ProductBrowser
          :saleType="'chakana'"
          :cart="cart"
          products-only
          @add-product="addProductToCart"
          @decrease-product="decreaseProductById"
        />
      </div>

      <div class="mg-cart-col">
        <div class="mg-cart-card">
          <div class="mg-cart-head">
            🛒 Tanlangan ({{ cart.length }})
            <button v-if="cart.length" class="mg-clear" @click="cart = []">
              Tozalash
            </button>
          </div>
          <div v-if="cart.length === 0" class="mg-cart-empty">
            Mahsulotlarni tanlang — chapdan brend/model yoki "Barchasi" orqali.
          </div>
          <div v-else class="mg-cart-items">
            <div
              v-for="(it, i) in cart"
              :key="it.id"
              class="mg-line"
              :class="{ 'mg-over': it.qty > it.balance }"
            >
              <div class="mg-line-top">
                <span class="mg-line-name">{{ it.name }}</span>
                <button
                  class="mg-del"
                  @click="cart.splice(i, 1)"
                  title="O'chirish"
                >
                  &times;
                </button>
              </div>
              <div class="mg-line-grid">
                <div class="mg-fld">
                  <label>Soni (qoldiq: {{ it.balance | numFormat }})</label>
                  <input
                    type="number"
                    v-model.number="it.qty"
                    min="0"
                    :max="it.balance"
                    step="any"
                    class="mg-in"
                  />
                </div>
                <div class="mg-fld">
                  <label>Narx (chakana)</label>
                  <input
                    type="number"
                    v-model.number="it.price"
                    min="0"
                    step="any"
                    class="mg-in"
                  />
                </div>
                <div class="mg-fld mg-fld-sum">
                  <label>Summa</label>
                  <div class="mg-line-sum">
                    {{ (it.qty * it.price) | numFormat }}
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div v-if="cart.length" class="mg-summary">
            <div class="mg-tot">
              Jami: <b>{{ totalValue | numFormat }} so'm</b>
            </div>
            <div
              v-if="ustaInfo && ustaInfo.mode === 'ball'"
              :class="['mg-calc', enough ? 'ok' : 'bad']"
            >
              <b v-if="ballCalc.moneySpent > 0"
                >-{{ ballCalc.moneySpent | numFormat }} pul</b
              >
              <b v-if="ballCalc.progressSpent > 0">
                -{{ ballCalc.progressSpent | numFormat }} limit</b
              >
              <b v-if="ballCalc.ballSpent > 0">
                -{{ ballCalc.ballSpent | numFormat }} ball</b
              >
              → qoladi: {{ ballCalc.moneyAfter | numFormat }} pul +
              {{ ballCalc.progressAfter | numFormat }} limit +
              {{ ballCalc.ballAfter | numFormat }} ball
              <span v-if="!enough"> ⚠️ yetarli emas</span>
            </div>
            <div
              v-else-if="ustaInfo"
              class="mg-calc"
              :class="{ bad: ustaInfo.money_balance - totalValue < 0 }"
            >
              Qoladi:
              <b
                >{{ (ustaInfo.money_balance - totalValue) | numFormat }} so'm</b
              >
              <span v-if="ustaInfo.money_balance - totalValue < 0">
                (qarzdor bo'ladi)</span
              >
            </div>
          </div>

          <textarea
            v-if="cart.length"
            v-model="comment"
            placeholder="Izoh (ixtiyoriy)"
            class="mg-in mg-textarea"
          ></textarea>
          <button
            class="mg-submit"
            :disabled="!canSubmit || saving"
            @click="submit"
          >
            <span v-if="saving">⏳ Saqlanmoqda...</span>
            <span v-else>✅ Berish ({{ cart.length }} ta)</span>
          </button>
        </div>
      </div>
    </div>

    <!-- ════════ AKSIYA MAHSULOT ════════ -->
    <div v-else-if="activeCat === 'aksiya'" class="mg-panel">
      <div v-if="aksiyaLoading" class="mg-muted">Yuklanmoqda...</div>
      <div v-else-if="ballProducts.length === 0" class="mg-muted">
        Aksiya mahsulotlari yo'q.
      </div>
      <div v-else class="mg-aksiya-grid">
        <div
          v-for="p in ballProducts"
          :key="p.id"
          class="mg-ak-card"
          :class="{ disabled: !canAfford(p) }"
        >
          <img v-if="p.image" :src="p.image" class="mg-ak-img" />
          <div v-else class="mg-ak-img mg-ak-ph">📦</div>
          <div class="mg-ak-name">{{ p.name }}</div>
          <div class="mg-ak-price">🎯 {{ p.ball_price | numFormat }} ball</div>
          <div v-if="!canAfford(p)" class="mg-ak-short">
            {{ (Number(p.ball_price) - ustaBall) | numFormat }} ball yetishmaydi
          </div>
          <button
            class="mg-ak-btn"
            :disabled="!canAfford(p) || aksiyaSaving"
            @click="giveAksiya(p)"
          >
            Berish
          </button>
        </div>
      </div>
    </div>

    <!-- ════════ PUL BERISH ════════ -->
    <div v-else-if="activeCat === 'cash'" class="mg-panel">
      <div class="mg-cash-card">
        <div class="mg-cash-bal">
          Joriy pul balansi: <b>{{ cashMoneyBalance | numFormat }} so'm</b>
        </div>
        <div class="mg-fld">
          <label class="mg-label">To'lov turi</label>
          <select v-model.number="cashPayType" class="mg-in mg-select">
            <option v-for="pt in payTypes" :key="pt.id" :value="pt.id">{{
              pt.name
            }}</option>
          </select>
        </div>
        <div class="mg-fld">
          <label class="mg-label">{{
            cashIsDollar ? "Summa ($ — dollar miqdori)" : "Summa (so'm)"
          }}</label>
          <input
            type="number"
            v-model.number="cashAmount"
            min="0"
            step="any"
            class="mg-in"
            placeholder="0"
          />
        </div>
        <div v-if="cashIsDollar" class="mg-fld">
          <label class="mg-label">Dollar kursi (so'm)</label>
          <input
            type="number"
            v-model.number="cashRate"
            min="0"
            step="any"
            class="mg-in"
            :placeholder="latestRate"
          />
          <small class="mg-muted-inline"
            >Bo'sh = oxirgi kurs ({{ latestRate | numFormat }})</small
          >
        </div>
        <div class="mg-fld">
          <label class="mg-label">Izoh (ixtiyoriy)</label>
          <input
            type="text"
            v-model="cashComment"
            class="mg-in"
            placeholder="..."
          />
        </div>
        <div
          v-if="cashAmount > 0 && ustaInfo"
          class="mg-calc"
          :class="{
            bad:
              (ustaInfo.mode === 'ball' && !cashEnough) ||
              (ustaInfo.mode !== 'ball' &&
                ustaInfo.money_balance - cashSumEquivalent < 0)
          }"
        >
          <div v-if="cashIsDollar">
            💵 ${{ cashAmount | numFormat }} × {{ cashRateNum | numFormat }} =
            <b>{{ cashSumEquivalent | numFormat }} so'm</b>
          </div>

          <!-- Ball usta: pul ham balldan/limitdan ayiriladi -->
          <template v-if="ustaInfo.mode === 'ball'">
            Ayiriladi:
            <b v-if="cashBallCalc.moneySpent > 0"
              >-{{ cashBallCalc.moneySpent | numFormat }} pul</b
            >
            <b v-if="cashBallCalc.progressSpent > 0">
              -{{ cashBallCalc.progressSpent | numFormat }} limit</b
            >
            <b v-if="cashBallCalc.ballSpent > 0">
              -{{ cashBallCalc.ballSpent | numFormat }} ball</b
            >
            → qoladi: {{ cashBallCalc.moneyAfter | numFormat }} pul +
            {{ cashBallCalc.progressAfter | numFormat }} limit +
            {{ cashBallCalc.ballAfter | numFormat }} ball
            <span v-if="!cashEnough"> ⚠️ yetarli emas</span>
          </template>

          <!-- Bonus usta: pul balansidan -->
          <template v-else>
            Berilgach balans:
            <b
              >{{
                (ustaInfo.money_balance - cashSumEquivalent) | numFormat
              }}
              so'm</b
            >
            <span v-if="ustaInfo.money_balance - cashSumEquivalent < 0">
              (usta qarzdor bo'ladi)</span
            >
          </template>

          <div class="mg-cash-note">
            <span v-if="cashIsDollar"
              >💵 Kassadan ${{ cashAmount | numFormat }} (dollar) chiqim
              yoziladi.</span
            >
            <span v-else
              >💵 Kassadan {{ cashAmount | numFormat }} so'm chiqim
              yoziladi.</span
            >
          </div>
        </div>
        <button
          class="mg-submit"
          :disabled="!(cashAmount > 0) || cashSaving || !cashEnough"
          @click="submitCash"
        >
          <span v-if="cashSaving">⏳ Saqlanmoqda...</span>
          <span v-else>✅ Pul berish</span>
        </button>
      </div>
    </div>

    <!-- ════════ TARIX ════════ -->
    <div class="mg-history">
      <div class="mg-hist-head">
        📜 Berilgan sovg'alar / to'lovlar tarixi
        <span class="mg-hist-sub">{{
          staff_id ? "(tanlangan usta)" : "(barcha ustalar)"
        }}</span>
      </div>
      <div v-if="historyLoading" class="mg-muted">Yuklanmoqda...</div>
      <div v-else-if="history.length === 0" class="mg-muted">
        Hali yozuv yo'q.
      </div>
      <table v-else class="mg-hist-table">
        <thead>
          <tr>
            <th>Sana</th>
            <th v-if="!staff_id">Usta</th>
            <th>Tur</th>
            <th>Tafsilot</th>
            <th class="r">Summa / Ball</th>
            <th class="r"></th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="h in history"
            :key="h.id"
            :class="{ 'mg-h-rev': isReversal(h) }"
          >
            <td class="mg-h-date">{{ formatDate(h.created_at) }}</td>
            <td v-if="!staff_id" class="mg-h-usta">
              {{ h.staff_name || "—" }}
            </td>
            <td>
              <span class="mg-badge" :class="h.category">{{
                catLabel(h.category)
              }}</span>
            </td>
            <td class="mg-h-doc">{{ h.doc_type }}</td>
            <td class="r">
              <span v-if="h.type === 'kirim'" class="mg-h-plus">
                <span v-if="h.ball > 0">+{{ h.ball | numFormat }} ball</span>
                <span v-else>+{{ h.summa | numFormat }} so'm</span>
              </span>
              <span v-else>
                <span v-if="h.ball > 0">−{{ h.ball | numFormat }} ball</span>
                <span v-else>−{{ h.summa | numFormat }} so'm</span>
              </span>
            </td>
            <td class="r mg-h-actions">
              <button
                v-if="!isReversal(h) && h.category === 'cash'"
                class="mg-edit-btn"
                @click="openEditCash(h)"
              >
                Tahrirlash
              </button>
              <button
                v-if="!isReversal(h) && h.type === 'chiqim'"
                class="mg-cancel-btn"
                :disabled="cancelingId === h.id"
                @click="cancelHistory(h)"
              >
                {{ cancelingId === h.id ? "..." : "Bekor" }}
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- ════════ PUL TO'LOVINI TAHRIRLASH MODALI ════════ -->
    <div v-if="editCashRow" class="mg-overlay" @click.self="editCashRow = null">
      <div class="mg-modal">
        <div class="mg-modal-head">
          <span>✏️ Pul to'lovini tuzatish</span>
          <button class="mg-modal-x" @click="editCashRow = null">
            &times;
          </button>
        </div>
        <div class="mg-modal-body">
          <div class="mg-modal-info">{{ editCashRow.doc_type }}</div>
          <div class="mg-fld">
            <label class="mg-label">To'lov turi</label>
            <select v-model.number="editPayType" class="mg-in mg-select">
              <option v-for="pt in payTypes" :key="pt.id" :value="pt.id">{{
                pt.name
              }}</option>
            </select>
          </div>
          <div class="mg-fld">
            <label class="mg-label">{{
              editIsDollar ? "Summa ($ — dollar miqdori)" : "Summa (so'm)"
            }}</label>
            <input
              type="number"
              v-model.number="editAmount"
              min="0"
              step="any"
              class="mg-in"
            />
          </div>
          <div v-if="editIsDollar" class="mg-fld">
            <label class="mg-label">Dollar kursi (so'm)</label>
            <input
              type="number"
              v-model.number="editRate"
              min="0"
              step="any"
              class="mg-in"
              :placeholder="latestRate"
            />
          </div>
          <div class="mg-fld">
            <label class="mg-label">Izoh</label>
            <input type="text" v-model="editComment" class="mg-in" />
          </div>
          <div class="mg-cash-note">
            💡 Kassa yozuvi to'g'rilanadi (dollar/so'm). So'm qiymati
            o'zgarmasa, ustaning balansiga tegilmaydi.
          </div>
        </div>
        <div class="mg-modal-foot">
          <button class="mg-modal-cancel" @click="editCashRow = null">
            Yopish
          </button>
          <button
            class="mg-modal-save"
            :disabled="!(editAmount > 0) || editSaving"
            @click="submitEditCash"
          >
            {{ editSaving ? "..." : "Saqlash" }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import ProductBrowser from "@/pages/Chiqim/components/ProductBrowser.vue";

export default {
  name: "UstaGiveProduct",
  components: { ProductBrowser },
  data() {
    return {
      activeCat: "aksiya",
      ustalar: [],
      staff_id: null,
      ustaInfo: null,
      // ombor
      cart: [],
      comment: "",
      saving: false,
      // aksiya
      ballProducts: [],
      aksiyaLoading: false,
      aksiyaSaving: false,
      // cash
      cashAmount: null,
      cashPayType: 1,
      cashComment: "",
      cashSaving: false,
      cashRate: null, // dollar kursi (bo'sh bo'lsa oxirgi kurs ishlatiladi)
      latestRate: 1,
      payTypes: [],
      // history
      history: [],
      historyLoading: false,
      cancelingId: null,
      // pul to'lovini tahrirlash
      editCashRow: null,
      editAmount: null,
      editPayType: 1,
      editRate: null,
      editComment: "",
      editSaving: false
    };
  },
  computed: {
    ustaBall() {
      return this.ustaInfo ? Number(this.ustaInfo.ball_balance || 0) : 0;
    },
    cashMoneyBalance() {
      return this.ustaInfo ? Number(this.ustaInfo.money_balance || 0) : 0;
    },
    cashIsDollar() {
      const pt = this.payTypes.find(p => p.id === this.cashPayType);
      const name = pt ? String(pt.name).toLowerCase() : "";
      return (
        this.cashPayType === 3 ||
        name.includes("dollar") ||
        name.includes("доллар") ||
        name.includes("$")
      );
    },
    cashRateNum() {
      return Number(this.cashRate || this.latestRate || 1);
    },
    editIsDollar() {
      const pt = this.payTypes.find(p => p.id === this.editPayType);
      const name = pt ? String(pt.name).toLowerCase() : "";
      return (
        this.editPayType === 3 ||
        name.includes("dollar") ||
        name.includes("доллар") ||
        name.includes("$")
      );
    },
    // Usta balansidan ayiriladigan so'm (dollar bo'lsa: miqdor × kurs)
    cashSumEquivalent() {
      const a = Number(this.cashAmount || 0);
      return this.cashIsDollar ? a * this.cashRateNum : a;
    },
    totalValue() {
      return this.cart.reduce(
        (s, it) => s + (Number(it.qty) || 0) * (Number(it.price) || 0),
        0
      );
    },
    ballNeeded() {
      if (
        !this.ustaInfo ||
        this.ustaInfo.mode !== "ball" ||
        !this.ustaInfo.ball_per_sum
      )
        return 0;
      return this.totalValue / this.ustaInfo.ball_per_sum;
    },
    // Ball rejimi: AVVAL limit (ball_progress) dan, keyin balldan — backend bilan bir xil
    ballCalc() {
      return this.splitBall(this.totalValue);
    },
    // Pul berishda ham (ball usta) — limit-first→ball bo'yicha taqsimot
    cashBallCalc() {
      return this.splitBall(this.cashSumEquivalent);
    },
    cashEnough() {
      if (!this.ustaInfo) return true;
      if (this.ustaInfo.mode === "ball")
        return (
          this.cashSumEquivalent <=
          Number(this.ustaInfo.available_value || 0) + 1e-6
        );
      return true; // bonus rejimi manfiyga ketishi mumkin (qarz)
    },
    enough() {
      if (!this.ustaInfo) return false;
      if (this.ustaInfo.mode === "ball")
        return (
          this.totalValue <= Number(this.ustaInfo.available_value || 0) + 1e-6
        );
      return true;
    },
    canSubmit() {
      if (!this.staff_id || this.cart.length === 0) return false;
      const linesOk = this.cart.every(
        it =>
          Number(it.qty) > 0 &&
          Number(it.price) >= 0 &&
          Number(it.qty) <= Number(it.balance) + 1e-6
      );
      return linesOk && this.totalValue > 0 && this.enough;
    }
  },
  mounted() {
    this.loadUstalar();
    this.loadPayTypes();
    this.loadRate();
    this.loadBallProducts();
    this.loadHistory(); // sahifa ochilishida — barcha ustalar tranzaksiyalari
  },
  methods: {
    selectCat(c) {
      this.activeCat = c;
      if (c === "aksiya" && this.ballProducts.length === 0)
        this.loadBallProducts();
      if (c === "cash" && this.payTypes.length === 0) this.loadPayTypes();
    },
    catLabel(c) {
      return c === "aksiya"
        ? "🎯 Aksiya"
        : c === "cash"
        ? "💵 Pul"
        : "📦 Ombor";
    },
    // Berilgan so'm qiymatini limit-first→ball bo'yicha taqsimlash (backend bilan bir xil)
    // Berilgan so'm qiymatini PUL(musbat) → LAHTAK(limit) → BALL bo'yicha taqsimlash
    splitBall(value) {
      const u = this.ustaInfo || {};
      const gbp = Number(u.ball_per_sum || 0);
      const ballBal = Number(u.ball_balance || 0);
      const progress = Number(u.ball_progress || 0);
      const money = Number(u.money_balance || 0);
      const moneyAvail = Math.max(0, money);
      const v = Number(value || 0);
      const fromMoney = Math.min(v, moneyAvail);
      let rem = v - fromMoney;
      const fromProgress = Math.min(rem, progress);
      rem -= fromProgress;
      const ballSpent = gbp > 0 ? rem / gbp : 0;
      return {
        moneySpent: fromMoney,
        progressSpent: fromProgress,
        ballSpent,
        moneyAfter: money - fromMoney,
        progressAfter: progress - fromProgress,
        ballAfter: ballBal - ballSpent
      };
    },
    isReversal(h) {
      const d = String(h.doc_type || "");
      return d.includes("BEKOR") || d.includes("TUZATISH");
    },
    openEditCash(h) {
      this.editCashRow = h;
      this.editAmount = Number(h.summa || 0) || null;
      this.editPayType =
        this.payTypes.length && this.payTypes[0] ? this.payTypes[0].id : 1;
      this.editRate = null;
      this.editComment = "";
    },
    async submitEditCash() {
      const amount = Number(this.editAmount);
      if (!(amount > 0)) return alert("Summani kiriting");
      this.editSaving = true;
      try {
        const res = await axios.put(
          "api/v1/master-gift/cash/" + this.editCashRow.id,
          {
            amount,
            pay_type_id: this.editPayType,
            dollar_rate: this.editIsDollar
              ? Number(this.editRate || this.latestRate || 1)
              : undefined,
            comment: this.editComment || undefined
          }
        );
        const d = res.data || {};
        let msg = "✅ Tuzatildi.";
        if (!d.staff_changed)
          msg += " (faqat kassa to'g'rilandi, balans o'zgarmadi)";
        alert(msg);
        this.editCashRow = null;
        if (this.staff_id) await this.onUstaChange();
        else await this.loadHistory();
      } catch (e) {
        alert("Xatolik: " + this.errMsg(e));
      } finally {
        this.editSaving = false;
      }
    },
    async cancelHistory(h) {
      if (this.isReversal(h)) return;
      if (
        !confirm(
          `Ushbu yozuv bekor qilinsinmi?\n${this.catLabel(h.category)} — ${
            h.doc_type
          }\n(ombor/ball/pul + kassa qaytariladi)`
        )
      )
        return;
      this.cancelingId = h.id;
      try {
        const res = await axios.post("api/v1/master-gift/cancel/" + h.id);
        alert("✅ " + ((res.data && res.data.message) || "Bekor qilindi"));
        if (this.staff_id) await this.onUstaChange();
        else await this.loadHistory();
      } catch (e) {
        alert("Xatolik: " + this.errMsg(e));
      } finally {
        this.cancelingId = null;
      }
    },
    chakana(item) {
      return item.price_register
        ? Number(item.price_register.chakana_price || 0)
        : 0;
    },
    canAfford(p) {
      return this.ustaBall >= Number(p.ball_price || 0);
    },
    formatDate(d) {
      if (!d) return "";
      const dt = new Date(d);
      return isNaN(dt) ? d : dt.toLocaleString("ru-RU");
    },
    errMsg(e) {
      return (
        (e.response &&
          e.response.data &&
          (e.response.data.message || e.response.data.error)) ||
        e.message
      );
    },
    async loadUstalar() {
      try {
        const res = await axios.get("api/v1/staff/ustalar");
        this.ustalar = (res.data && res.data.data) || [];
      } catch (e) {
        alert("Ustalarni yuklashda xato: " + this.errMsg(e));
      }
    },
    async loadPayTypes() {
      try {
        const res = await axios.get("api/v1/pay-type/");
        this.payTypes = Array.isArray(res.data)
          ? res.data
          : res.data.data || [];
        if (
          this.payTypes.length &&
          !this.payTypes.find(p => p.id === this.cashPayType)
        ) {
          this.cashPayType = this.payTypes[0].id;
        }
      } catch (e) {
        console.error(e);
      }
    },
    async loadRate() {
      try {
        const res = await axios.get("api/v1/dollar-exchange-rate/last");
        const r =
          res.data && (res.data.rate || (res.data.data && res.data.data.rate));
        if (Number(r) > 0) this.latestRate = Number(r);
      } catch (e) {
        // kurs olinmasa — backend oxirgi kursni o'zi ishlatadi
      }
    },
    async loadBallProducts() {
      this.aksiyaLoading = true;
      try {
        const res = await axios.get("api/v1/ball-product?active=1");
        this.ballProducts = (res.data && res.data.data) || [];
      } catch (e) {
        console.error(e);
        this.ballProducts = [];
      } finally {
        this.aksiyaLoading = false;
      }
    },
    async onUstaChange() {
      this.ustaInfo = null;
      this.cart = [];
      // Usta tanlanmasa — balansni tozalaymiz, lekin tarixni BARCHA ustalar bo'yicha ko'rsatamiz
      if (this.staff_id) {
        try {
          const res = await axios.get(
            "api/v1/master-gift/usta/" + this.staff_id
          );
          this.ustaInfo = res.data;
        } catch (e) {
          alert("Usta balansini olishda xato: " + this.errMsg(e));
        }
      }
      this.loadHistory();
    },
    async loadHistory() {
      this.historyLoading = true;
      try {
        // staff_id bo'lsa — filtr; bo'lmasa — barcha ustalar tranzaksiyalari (backend filtri)
        const params = { limit: 100 };
        if (this.staff_id) params.staff_id = this.staff_id;
        const res = await axios.get("api/v1/master-gift/history", { params });
        this.history = (res.data && res.data.items) || [];
      } catch (e) {
        console.error(e);
        this.history = [];
      } finally {
        this.historyLoading = false;
      }
    },
    // ── Ombor ──
    addProductToCart(item) {
      const balance = Number(item.balance || 0);
      if (balance <= 0) {
        alert("Bu mahsulot omborda yo'q (qoldiq 0)");
        return;
      }
      const existing = this.cart.find(
        c => c.type === "product" && c.id === item.id
      );
      if (existing) {
        if (Number(existing.qty) + 1 <= balance)
          existing.qty = Number(existing.qty) + 1;
        else alert(`Qoldiqdan ko'p: maksimum ${balance}`);
      } else {
        this.cart.push({
          type: "product",
          id: item.id,
          name: item.name || item.extra_name,
          qty: 1,
          price: this.chakana(item),
          balance,
          price_register: item.price_register
        });
      }
    },
    decreaseProductById(id) {
      const idx = this.cart.findIndex(c => c.type === "product" && c.id === id);
      if (idx === -1) return;
      const it = this.cart[idx];
      it.qty = Number(it.qty) - 1;
      if (it.qty <= 0) this.cart.splice(idx, 1);
    },
    async submit() {
      const sklad_id = localStorage.getItem("sklad_id");
      if (!(sklad_id > 0)) return alert("Avval ombor (sklad) tanlang");
      if (!this.canSubmit) return;
      const items = this.cart.map(it => ({
        product_id: it.id,
        count: Number(it.qty),
        price: Number(it.price)
      }));
      if (
        !confirm(
          `${
            this.cart.length
          } ta mahsulot (${this.totalValue.toLocaleString()} so'm) ustaga beriladi. Davom etamizmi?`
        )
      )
        return;

      this.saving = true;
      try {
        const res = await axios.post("api/v1/master-gift", {
          staff_id: this.staff_id,
          sklad_id: Number(sklad_id),
          comment: this.comment || undefined,
          items
        });
        const d = res.data || {};
        let msg = "✅ Berildi!\n";
        if (d.deduct_mode === "ball")
          msg += `Sarflangan ball: ${Number(
            d.ball_spent
          ).toLocaleString()}\nQolgan ball: ${Number(
            d.new_ball_balance
          ).toLocaleString()}`;
        else
          msg += `Ayirilgan summa: ${Number(
            d.value_sum
          ).toLocaleString()} so'm\nYangi pul balansi: ${Number(
            d.new_money_balance
          ).toLocaleString()} so'm`;
        alert(msg);
        this.cart = [];
        this.comment = "";
        await this.onUstaChange();
      } catch (e) {
        alert("Xatolik: " + this.errMsg(e));
      } finally {
        this.saving = false;
      }
    },
    // ── Aksiya ──
    async giveAksiya(p) {
      if (!this.staff_id) return alert("Avval ustani tanlang");
      if (!this.canAfford(p)) return alert("Ball yetarli emas");
      if (
        !confirm(
          `"${p.name}" berilsinmi? ${Number(
            p.ball_price
          ).toLocaleString()} ball ayriladi.`
        )
      )
        return;
      this.aksiyaSaving = true;
      try {
        const res = await axios.post(`api/v1/ball-product/${p.id}/give`, {
          staff_id: this.staff_id,
          comment: undefined
        });
        const nb =
          (res.data && res.data.data && res.data.data.ball_balance) ?? "?";
        alert(
          `✅ Berildi!\nYangi ball balansi: ${Number(nb).toLocaleString()} ball`
        );
        await this.onUstaChange();
      } catch (e) {
        alert("Xatolik: " + this.errMsg(e));
      } finally {
        this.aksiyaSaving = false;
      }
    },
    // ── Pul berish (dollar-aware: kassada dollar miqdori, balansda so'm ekvivalenti) ──
    async submitCash() {
      const sklad_id = localStorage.getItem("sklad_id");
      if (!(sklad_id > 0)) return alert("Avval ombor (sklad) tanlang");
      const amount = Number(this.cashAmount);
      if (!(amount > 0)) return alert("Summani kiriting");
      const human = this.cashIsDollar
        ? `$${amount.toLocaleString()} (≈ ${this.cashSumEquivalent.toLocaleString()} so'm)`
        : `${amount.toLocaleString()} so'm`;
      if (
        !confirm(
          `${human} ${this.ustaName()} ga beriladi (kassadan chiqim). Davom etamizmi?`
        )
      )
        return;

      this.cashSaving = true;
      try {
        const res = await axios.post("api/v1/master-gift/cash", {
          staff_id: this.staff_id,
          sklad_id: Number(sklad_id),
          amount,
          pay_type_id: this.cashPayType,
          dollar_rate: this.cashIsDollar ? this.cashRateNum : undefined,
          comment: this.cashComment || undefined
        });
        const d = res.data || {};
        let msg = "✅ Pul berildi (balansdan + kassadan chiqim).";
        if (d.is_dollar)
          msg += `\nKassadan: $${Number(
            d.kassa_summa
          ).toLocaleString()} | Balansdan: ${Number(
            d.sum_equivalent
          ).toLocaleString()} so'm`;
        alert(msg);
        this.cashAmount = null;
        this.cashComment = "";
        this.cashRate = null;
        await this.onUstaChange();
      } catch (e) {
        alert("Xatolik: " + this.errMsg(e));
      } finally {
        this.cashSaving = false;
      }
    },
    ustaName() {
      const u = this.ustalar.find(x => x.id === this.staff_id);
      return u ? u.name : "usta";
    }
  }
};
</script>

<style scoped>
.mg-page {
  padding: 14px;
}
.mg-header {
  background: #fff;
  border-radius: 14px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);
  padding: 14px 18px;
  margin-bottom: 12px;
}
.mg-title {
  margin: 0 0 12px;
  font-size: 20px;
  font-weight: 800;
  color: #1f2937;
}

/* Kategoriya tugmalari */
.mg-cats {
  display: flex;
  gap: 10px;
  margin-bottom: 14px;
  flex-wrap: wrap;
}
.mg-cat {
  flex: 1;
  min-width: 150px;
  background: #f8fafc;
  border: 2px solid #e5e7eb;
  border-radius: 12px;
  padding: 12px;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 2px;
  transition: 0.15s;
}
.mg-cat:hover {
  border-color: #c7d2fe;
}
.mg-cat.active {
  border-color: #4f46e5;
  background: #eef2ff;
}
.mg-cat-ic {
  font-size: 24px;
}
.mg-cat-name {
  font-weight: 800;
  color: #1f2937;
  font-size: 14px;
}
.mg-cat-sub {
  font-size: 11px;
  color: #6b7280;
}

.mg-head-row {
  display: flex;
  gap: 16px;
  flex-wrap: wrap;
  align-items: flex-start;
}
.mg-usta-pick {
  flex: 1;
  min-width: 240px;
}
.mg-label {
  display: block;
  font-weight: 600;
  color: #374151;
  margin-bottom: 6px;
  font-size: 13px;
}
.mg-balance {
  border-radius: 12px;
  padding: 10px 14px;
  border: 1px solid #bbf7d0;
  background: #f0fdf4;
  min-width: 260px;
  flex: 1;
}
.mg-bal-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 2px 0;
}
.mg-bal-label {
  color: #6b7280;
  font-size: 13px;
}
.mg-bal-val {
  font-weight: 700;
  color: #111827;
  font-size: 15px;
}
.mg-bal-val small {
  font-weight: 500;
  color: #6b7280;
  font-size: 12px;
}

.mg-empty {
  text-align: center;
  color: #9ca3af;
  padding: 40px;
  font-size: 15px;
}
.mg-muted {
  color: #9ca3af;
  font-size: 14px;
  padding: 24px;
  text-align: center;
}
.mg-panel {
  background: #fff;
  border-radius: 14px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);
  padding: 16px;
}

/* Ombor */
.mg-body {
  display: flex;
  gap: 14px;
  align-items: flex-start;
}
.mg-browser {
  flex: 2;
  min-width: 0;
}
.mg-cart-col {
  flex: 1;
  min-width: 300px;
  max-width: 420px;
}
.mg-cart-card {
  background: #fff;
  border-radius: 14px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);
  padding: 14px;
  position: sticky;
  top: 12px;
}
.mg-cart-head {
  font-weight: 800;
  color: #1f2937;
  font-size: 16px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
}
.mg-clear {
  border: 0;
  background: #f1f5f9;
  color: #64748b;
  border-radius: 8px;
  padding: 4px 10px;
  font-size: 12px;
  cursor: pointer;
}
.mg-cart-empty {
  color: #9ca3af;
  font-size: 13px;
  padding: 20px 0;
  text-align: center;
}
.mg-cart-items {
  max-height: 46vh;
  overflow-y: auto;
}
.mg-line {
  border: 1px solid #eef2f7;
  border-radius: 10px;
  padding: 10px;
  margin-bottom: 8px;
}
.mg-line.mg-over {
  border-color: #fca5a5;
  background: #fef2f2;
}
.mg-line-top {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 6px;
}
.mg-line-name {
  font-weight: 700;
  color: #1f2937;
  font-size: 14px;
}
.mg-del {
  border: 0;
  background: #fee2e2;
  color: #dc2626;
  width: 26px;
  height: 26px;
  border-radius: 8px;
  font-size: 17px;
  line-height: 1;
  cursor: pointer;
}
.mg-line-grid {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  gap: 8px;
}
.mg-fld label {
  display: block;
  font-size: 11px;
  color: #6b7280;
  margin-bottom: 3px;
}
.mg-in {
  width: 100%;
  height: 36px;
  border: 1px solid #d1d5db;
  border-radius: 8px;
  padding: 0 10px;
  box-sizing: border-box;
  font-size: 14px;
}
.mg-line-grid .mg-in {
  text-align: right;
}
.mg-select {
  text-align: left;
}
.mg-fld-sum .mg-line-sum {
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  font-weight: 700;
  color: #111827;
}
.mg-textarea {
  height: 56px;
  padding: 8px 12px;
  margin: 10px 0;
  resize: vertical;
}
.mg-summary {
  background: #f9fafb;
  border-radius: 10px;
  padding: 10px 12px;
  margin: 12px 0 8px;
}
.mg-tot {
  font-size: 16px;
  color: #1f2937;
}
.mg-calc {
  margin-top: 6px;
  font-size: 13px;
  padding: 8px 10px;
  border-radius: 8px;
  background: #ecfdf5;
  color: #047857;
}
.mg-calc.ok {
  background: #ecfdf5;
  color: #047857;
}
.mg-calc.bad {
  background: #fef2f2;
  color: #b91c1c;
}
.mg-cash-note {
  margin-top: 4px;
  font-size: 12px;
  color: #92400e;
}
.mg-submit {
  width: 100%;
  height: 48px;
  background: #4f46e5;
  color: #fff;
  border: 0;
  border-radius: 12px;
  font-size: 16px;
  font-weight: 700;
  cursor: pointer;
  transition: opacity 0.2s;
  margin-top: 6px;
}
.mg-submit:hover:not(:disabled) {
  opacity: 0.92;
}
.mg-submit:disabled {
  background: #c7d2fe;
  cursor: not-allowed;
}

/* Aksiya grid */
.mg-aksiya-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(160px, 1fr));
  gap: 12px;
}
.mg-ak-card {
  border: 1px solid #f1f5f9;
  border-radius: 12px;
  padding: 12px;
  text-align: center;
  background: #fffbeb;
  border-color: #fde68a;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 6px;
}
.mg-ak-card.disabled {
  opacity: 0.6;
}
.mg-ak-img {
  width: 64px;
  height: 64px;
  object-fit: cover;
  border-radius: 10px;
  background: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 30px;
}
.mg-ak-name {
  font-weight: 700;
  color: #92400e;
  font-size: 13px;
}
.mg-ak-price {
  font-weight: 800;
  color: #d97706;
  font-size: 14px;
}
.mg-ak-short {
  font-size: 11px;
  color: #b91c1c;
  font-weight: 700;
}
.mg-ak-btn {
  width: 100%;
  height: 36px;
  border: 0;
  border-radius: 10px;
  background: #16a34a;
  color: #fff;
  font-weight: 700;
  cursor: pointer;
  margin-top: auto;
}
.mg-ak-btn:disabled {
  background: #cbd5e1;
  cursor: not-allowed;
}

/* Cash */
.mg-cash-card {
  max-width: 440px;
}
.mg-cash-bal {
  background: #f0fdf4;
  border: 1px solid #bbf7d0;
  border-radius: 10px;
  padding: 10px 14px;
  margin-bottom: 14px;
  font-size: 14px;
  color: #166534;
}
.mg-cash-card .mg-fld {
  margin-bottom: 12px;
}

/* Tarix */
.mg-history {
  background: #fff;
  border-radius: 14px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);
  padding: 14px 18px;
  margin-top: 14px;
}
.mg-hist-head {
  font-weight: 800;
  color: #1f2937;
  font-size: 15px;
  margin-bottom: 10px;
}
.mg-hist-sub {
  font-weight: 600;
  font-size: 12px;
  color: #94a3b8;
  margin-left: 6px;
}
.mg-h-usta {
  font-weight: 700;
  color: #334155;
  white-space: nowrap;
}
.mg-hist-table {
  width: 100%;
  border-collapse: collapse;
}
.mg-hist-table th {
  text-align: left;
  font-size: 12px;
  color: #6b7280;
  padding: 6px 8px;
  border-bottom: 2px solid #e5e7eb;
}
.mg-hist-table th.r,
.mg-hist-table td.r {
  text-align: right;
}
.mg-hist-table td {
  padding: 8px;
  border-bottom: 1px solid #f3f4f6;
  font-size: 13px;
  color: #374151;
}
.mg-h-date {
  white-space: nowrap;
  color: #6b7280;
}
.mg-h-doc {
  color: #475569;
}
.mg-badge {
  font-size: 11px;
  font-weight: 700;
  padding: 2px 8px;
  border-radius: 999px;
  white-space: nowrap;
}
.mg-badge.aksiya {
  background: #fef3c7;
  color: #b45309;
}
.mg-badge.ombor {
  background: #dbeafe;
  color: #1d4ed8;
}
.mg-badge.cash {
  background: #dcfce7;
  color: #15803d;
}
.mg-h-actions {
  white-space: nowrap;
  display: flex;
  gap: 6px;
  justify-content: flex-end;
}
.mg-edit-btn {
  border: 1px solid #bfdbfe;
  background: #eff6ff;
  color: #1d4ed8;
  border-radius: 8px;
  padding: 3px 10px;
  font-size: 12px;
  font-weight: 700;
  cursor: pointer;
}
.mg-edit-btn:hover {
  background: #dbeafe;
}
.mg-cancel-btn {
  border: 1px solid #fecaca;
  background: #fef2f2;
  color: #dc2626;
  border-radius: 8px;
  padding: 3px 10px;
  font-size: 12px;
  font-weight: 700;
  cursor: pointer;
}
.mg-overlay {
  position: fixed;
  inset: 0;
  background: rgba(15, 23, 42, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9600;
}
.mg-modal {
  background: #fff;
  border-radius: 16px;
  width: 420px;
  max-width: 94vw;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.2);
  overflow: hidden;
}
.mg-modal-head {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 14px 18px;
  border-bottom: 1px solid #f1f5f9;
  font-weight: 800;
  color: #1f2937;
}
.mg-modal-x {
  border: 0;
  background: #f1f5f9;
  width: 30px;
  height: 30px;
  border-radius: 50%;
  font-size: 20px;
  cursor: pointer;
  color: #64748b;
}
.mg-modal-body {
  padding: 16px 18px;
}
.mg-modal-info {
  background: #f8fafc;
  border-radius: 8px;
  padding: 8px 10px;
  font-size: 12px;
  color: #475569;
  margin-bottom: 12px;
  word-break: break-word;
}
.mg-modal-body .mg-fld {
  margin-bottom: 12px;
}
.mg-modal-foot {
  display: flex;
  gap: 10px;
  padding: 12px 18px;
  border-top: 1px solid #f1f5f9;
}
.mg-modal-cancel {
  flex: 1;
  height: 42px;
  background: #f1f5f9;
  color: #64748b;
  border: 0;
  border-radius: 10px;
  font-weight: 700;
  cursor: pointer;
}
.mg-modal-save {
  flex: 2;
  height: 42px;
  background: #4f46e5;
  color: #fff;
  border: 0;
  border-radius: 10px;
  font-weight: 800;
  cursor: pointer;
}
.mg-modal-save:disabled {
  background: #c7d2fe;
  cursor: not-allowed;
}
.mg-cancel-btn:hover:not(:disabled) {
  background: #fee2e2;
}
.mg-cancel-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}
.mg-h-rev {
  opacity: 0.6;
}
.mg-h-rev .mg-h-doc {
  font-style: italic;
}
.mg-h-plus {
  color: #15803d;
  font-weight: 600;
}
.mg-muted-inline {
  display: block;
  margin-top: 3px;
  font-size: 11px;
  color: #9ca3af;
}

@media (max-width: 992px) {
  .mg-body {
    flex-direction: column;
  }
  .mg-browser,
  .mg-cart-col {
    width: 100%;
    max-width: none;
    flex: none;
  }
  .mg-cart-card {
    position: static;
  }
}
</style>
